import Calendar from '../../components/Calendar/Calendar'

const ManageRoster = () => {
  // const [classNames] = useOutletContext();
  // const [assignEmployeeModalOpen, setAssignEmployeeModalOpen] = useState(false);

  // const [currentDate, setCurrentDate] = useState(new Date());
  // const [days, setDays] = useState([]);
  // const [rosters, setRosters] = useState([]);

  // const selectedDay = days.find(day => day.isSelected) || days.find(day => day.isToday);

  // const generateCalendarDays = (year, month) => {
  //   const firstDay = new Date(year, month, 1);
  //   const lastDay = new Date(year, month + 1, 0);
  //   const daysInMonth = lastDay.getDate();
  //   const startDay = firstDay.getDay();
    
  //   const daysArray = [];
  //   // Add previous month days
  //   const prevMonthLastDay = new Date(year, month, 0).getDate();
  //   for (let i = startDay - 2; i >= 0; i--) {
  //     daysArray.push({
  //       date: `${year}-${String(month).padStart(2, '0')}-${String(prevMonthLastDay - i).padStart(2, '0')}`,
  //       isCurrentMonth: false,
  //       employees: []
  //     });
  //   }
    
  //   // Add current month days
  //   for (let i = 1; i <= daysInMonth; i++) {
  //     const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(i).padStart(2, '0')}`;
  //     daysArray.push({
  //       date: dateStr,
  //       isCurrentMonth: true,
  //       isToday: new Date().toISOString().split('T')[0] === dateStr,
  //       employees: []
  //     });
  //   }
    
  //   // Add next month days
  //   const remainingDays = 42 - daysArray.length; // 6 rows * 7 columns
  //   for (let i = 1; i <= remainingDays; i++) {
  //     daysArray.push({
  //       date: `${year}-${String(month + 2).padStart(2, '0')}-${String(i).padStart(2, '0')}`,
  //       isCurrentMonth: false,
  //       employees: []
  //     });
  //   }
    
  //   return daysArray;
  // };

  // useEffect(() => {
  //   const fetchRosters = async () => {
  //     try {
  //       const year = currentDate.getFullYear();
  //       const month = currentDate.getMonth();
        
  //       // Generate initial empty calendar
  //       const initialDays = generateCalendarDays(year, month);
  //       setDays(initialDays);

  //       // Fetch rosters using Axios
  //       const response = await api.get(`/roster/byMonthAndYear/${month + 1}/${year}`);
        
  //       const data = response.data;

  //       const updatedDays = initialDays.map(day => {
  //         const dayRosters = data.filter(roster => 
  //           new Date(roster.date).toISOString().split('T')[0] === day.date
  //         );
  //         return {
  //           ...day,
  //           employees: dayRosters.map(roster => ({
  //             id: roster._id,
  //             name: `${roster.employeeId.firstName} ${roster.employeeId.lastName}`,
  //             shiftStart: new Date(roster.shiftStart).toLocaleTimeString([], { 
  //               hour: '2-digit', 
  //               minute: '2-digit' 
  //             }),
  //             shiftEnd: new Date(roster.shiftEnd).toLocaleTimeString([], { 
  //               hour: '2-digit', 
  //               minute: '2-digit' 
  //             }),
  //             href: `#roster-${roster._id}`
  //           }))
  //         };
  //       });
        
  //       setDays(updatedDays);
  //       setRosters(data);
  //     } catch (error) {
  //       console.error('Error fetching rosters:', error);
  //     }
  //   };

  //   // Execute the async function
  //   fetchRosters();
  // }, [currentDate]);

  // const handlePrevMonth = () => {
  //   setCurrentDate(new Date(currentDate.setMonth(currentDate.getMonth() - 1)));
  // };

  // const handleNextMonth = () => {
  //   setCurrentDate(new Date(currentDate.setMonth(currentDate.getMonth() + 1)));
  // };

  // const handleAssignSuccessfully = () => {
  //   setCurrentDate(new Date(currentDate));
  // }

  return (
    // <div className="lg:flex lg:h-full lg:flex-col">
    //   <header className="flex items-center justify-between border-b border-gray-200 px-6 py-4 lg:flex-none">
    //     <h1 className="text-base font-semibold text-gray-900">
    //       <time dateTime={currentDate.toISOString().split('T')[0]}>
    //         {currentDate.toLocaleString('default', { month: 'long', year: 'numeric' })}
    //       </time>
    //     </h1>
    //     <div className="flex items-center">
    //       <div className="relative flex items-center rounded-md bg-white shadow-sm md:items-stretch">
    //         <button onClick={handlePrevMonth} className="flex h-9 w-12 items-center justify-center rounded-l-md border-y border-l border-gray-300 pr-1 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:pr-0 md:hover:bg-gray-50">
    //           <span className="sr-only">Previous month</span>
    //           <ChevronLeftIcon className="size-5" aria-hidden="true" />
    //         </button>
    //         <button className="hidden border-y border-gray-300 px-3.5 text-sm font-semibold text-gray-900 hover:bg-gray-50 focus:relative md:block"
    //           onClick={() => setCurrentDate(new Date())}>
    //           Current month
    //         </button>
    //         <span className="relative -mx-px h-5 w-px bg-gray-300 md:hidden" />
    //         <button onClick={handleNextMonth} className="flex h-9 w-12 items-center justify-center rounded-r-md border-y border-r border-gray-300 pl-1 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:pl-0 md:hover:bg-gray-50">
    //           <span className="sr-only">Next month</span>
    //           <ChevronRightIcon className="size-5" aria-hidden="true" />
    //         </button>
    //       </div>
    //       <div className="hidden md:ml-4 md:flex md:items-center">
    //         <Menu as="div" className="relative">
    //           <MenuButton
    //             type="button"
    //             className="flex items-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
    //           >
    //             Month view
    //             <ChevronDownIcon className="-mr-1 size-5 text-gray-400" aria-hidden="true" />
    //           </MenuButton>

    //           <MenuItems
    //             transition
    //             className="absolute right-0 z-10 mt-3 w-36 origin-top-right overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
    //           >
    //             <div className="py-1">
    //               <MenuItem>
    //                 <a
    //                   href="/"
    //                   className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
    //                 >
    //                   Day view
    //                 </a>
    //               </MenuItem>
    //               <MenuItem>
    //                 <a
    //                   href="/"
    //                   className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
    //                 >
    //                   Week view
    //                 </a>
    //               </MenuItem>
    //               <MenuItem>
    //                 <a
    //                   href="/"
    //                   className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
    //                 >
    //                   Month view
    //                 </a>
    //               </MenuItem>
    //               <MenuItem>
    //                 <a
    //                   href="/"
    //                   className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
    //                 >
    //                   Year view
    //                 </a>
    //               </MenuItem>
    //             </div>
    //           </MenuItems>
    //         </Menu>
    //         <div className="ml-6 h-6 w-px bg-gray-300" />
    //         <button
    //           type="button"
    //           className="ml-6 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
    //           onClick={() => setAssignEmployeeModalOpen(true)}
    //         >
    //           Assign employee
    //         </button>
    //       </div>
    //       <Menu as="div" className="relative ml-6 md:hidden">
    //         <MenuButton className="-mx-2 flex items-center rounded-full border border-transparent p-2 text-gray-400 hover:text-gray-500">
    //           <span className="sr-only">Open menu</span>
    //           <EllipsisHorizontalIcon className="size-5" aria-hidden="true" />
    //         </MenuButton>

    //         <MenuItems
    //           transition
    //           className="absolute right-0 z-10 mt-3 w-36 origin-top-right divide-y divide-gray-100 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
    //         >
    //           <div className="py-1">
    //             <MenuItem>
    //               <button
    //                 type='button'
    //                 className="w-full px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none text-left"
    //                 onClick={() => setAssignEmployeeModalOpen(true)}
    //               >
    //                 Assign employee
    //               </button>
    //             </MenuItem>
    //           </div>
    //           <div className="py-1">
    //             <MenuItem>
    //               <a
    //                 href="/"
    //                 className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
    //               >
    //                 Go to today
    //               </a>
    //             </MenuItem>
    //           </div>
    //           <div className="py-1">
    //             <MenuItem>
    //               <a
    //                 href="/"
    //                 className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
    //               >
    //                 Day view
    //               </a>
    //             </MenuItem>
    //             <MenuItem>
    //               <a
    //                 href="/"
    //                 className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
    //               >
    //                 Week view
    //               </a>
    //             </MenuItem>
    //             <MenuItem>
    //               <a
    //                 href="/"
    //                 className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
    //               >
    //                 Month view
    //               </a>
    //             </MenuItem>
    //             <MenuItem>
    //               <a
    //                 href="/"
    //                 className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
    //               >
    //                 Year view
    //               </a>
    //             </MenuItem>
    //           </div>
    //         </MenuItems>
    //       </Menu>
    //     </div>
    //   </header>
    //   <div className="shadow ring-1 ring-black/5 lg:flex lg:flex-auto lg:flex-col">
    //     <div className="grid grid-cols-7 gap-px border-b border-gray-300 bg-gray-200 text-center text-xs/6 font-semibold text-gray-700 lg:flex-none">
    //       {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map(day => (
    //         <div key={day} className="bg-white py-2">{day[0]}<span className="sr-only sm:not-sr-only">{day.slice(1)}</span></div>
    //       ))}
    //     </div>
    //     <div className="flex bg-gray-200 text-xs/6 text-gray-700 lg:flex-auto">
    //       <div className="hidden w-full lg:grid lg:grid-cols-7 lg:grid-rows-6 lg:gap-px">
    //         {days.map((day) => (
    //             <div
    //               key={day.date}
    //               className={classNames(
    //                 day.isCurrentMonth ? 'bg-white' : 'bg-gray-50 text-gray-500',
    //                 'relative px-3 py-2'
    //               )}
    //             >
    //               <time
    //                 dateTime={day.date}
    //                 className={day.isToday ? 'flex size-6 items-center justify-center rounded-full bg-indigo-600 font-semibold text-white' : undefined}
    //               >
    //                 {day.date.split('-')[2].replace(/^0/, '')}
    //               </time>
    //               {day.employees.length > 0 && (
    //                 <ol className="mt-2">
    //                   {day.employees.slice(0, 2).map((employee) => (
    //                     <li key={employee.id}>
    //                       <a href={employee.href} className="group flex">
    //                         <p className="flex-auto truncate font-medium text-gray-900 group-hover:text-indigo-600">
    //                           {employee.name}
    //                         </p>
    //                         <time className="ml-3 hidden flex-none text-gray-500 group-hover:text-indigo-600 xl:block">
    //                           {employee.shiftStart} - {employee.shiftEnd}
    //                         </time>
    //                       </a>
    //                     </li>
    //                   ))}
    //                   {day.employees.length > 2 && <li className="text-gray-500">+ {day.employees.length - 2} more</li>}
    //                 </ol>
    //               )}
    //             </div>
    //           ))}
    //       </div>
    //       <div className="isolate grid w-full grid-cols-7 grid-rows-6 gap-px lg:hidden">
    //         {days.map((day) => (
    //             <button
    //               key={day.date}
    //               type="button"
    //               className={classNames(
    //                 day.isCurrentMonth ? 'bg-white' : 'bg-gray-50',
    //                 day.isToday && 'font-semibold text-indigo-600',
    //                 'flex h-14 flex-col px-3 py-2 hover:bg-gray-100 focus:z-10'
    //               )}
    //             >
    //               <time dateTime={day.date} className="ml-auto">
    //                 {day.date.split('-')[2].replace(/^0/, '')}
    //               </time>
    //               <span className="sr-only">{day.employees.length} employees</span>
    //               {day.employees.length > 0 && (
    //                 <span className="-mx-0.5 mt-auto flex flex-wrap-reverse">
    //                   {day.employees.map((employee) => (
    //                     <span key={employee.id} className="mx-0.5 mb-1 size-1.5 rounded-full bg-gray-400" />
    //                   ))}
    //                 </span>
    //               )}
    //             </button>
    //           ))}
    //       </div>
    //     </div>
    //   </div>
    //   {selectedDay?.employees.length > 0 && (
    //     <div className="px-4 py-10 sm:px-6 lg:hidden">
    //       <ol className="divide-y divide-gray-100 overflow-hidden rounded-lg bg-white text-sm shadow ring-1 ring-black/5">
    //         {selectedDay.employees.map((employee) => (
    //           <li key={employee.id} className="group flex p-4 pr-6 focus-within:bg-gray-50 hover:bg-gray-50">
    //             <div className="flex-auto">
    //               <p className="font-semibold text-gray-900">{employee.name}</p>
    //               <time className="mt-2 flex items-center text-gray-700">
    //                 <ClockIcon className="mr-2 size-5 text-gray-400" aria-hidden="true" />
    //                 {employee.shiftStart} - {employee.shiftEnd}
    //               </time>
    //             </div>
    //           </li>
    //         ))}
    //       </ol>
    //     </div>
    //   )}

    // <AssignEmployeeModal assignEmployeeModalOpen={assignEmployeeModalOpen} setAssignEmployeeModalOpen={setAssignEmployeeModalOpen} handleAssignSuccessfully={handleAssignSuccessfully} />
    
    // <Calendar />
    
    // </div>
    <>
      <Calendar />
    </>
  )
}

export default ManageRoster